/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  TeamList: [],

  // loading:false
}

/////////////////////////superAdmin////////////////////////////////////

export const CreateTeamProfile: any = createAsyncThunk(
  '/CreateTeamProfile',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}user/createSubAccount`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    response?.data?.status == true && toast?.success(response?.data?.message)
    thunkApi.dispatch(
      GetAllTeamList({
        ownerId: data?.ownerMainUserId,
      })
    )

    return response.data
  }
)

export const GetAllTeamList: any = createAsyncThunk(
  '/GetAllTeamList',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}user/getlistofSubAccount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const DeleteTeamProfile: any = createAsyncThunk(
  '/DeleteTeamProfile',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}user/deleteSubAccount`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(
      GetAllTeamList({
        ownerId: data?.ownerId,
      })
    )

    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }

    return response.data
  }
)

export const updateTeamProfile: any = createAsyncThunk(
  '/updateTeamProfile',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(
      `${API_URL}user/updateSubAccount/${data?.id}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(
      GetAllTeamList({
        ownerId: data?.ownerMainUserId,
      })
    )

    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }

    return response.data
  }
)

const TeamList = createSlice({
  name: 'staffAccount',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////OWNER ///////////////////////////////////////////////////////////////////

    [GetAllTeamList.fulfilled]: (state, {payload}) => {
      return {...state, TeamList: payload.data}
    },
  },
})

export default TeamList.reducer
